import { createReducer, on } from '@ngrx/store';
import * as ReferencesActions from './references.actions';
import { initialState } from './references.state';

export const referencesReducer = createReducer(
  initialState,
  
  on(ReferencesActions.showReferences, (state, { id }) => ({
    ...state,
    id,
    references: null,
    isBusy: true,
  })),
  
  on(ReferencesActions.showReferencesSuccess, (state, { result }) => ({
    ...state,
    references: result,
    isBusy: false,
  })),
  
  on(ReferencesActions.loadMore, state => ({
    ...state,
    isBusy: true,
  })),
  
  on(ReferencesActions.loadMoreSuccess, (state, { result }) => {
    const newState = {
      ...state,
      isBusy: false,
    };
    newState.references.total = result.total;
    for (const r of result.references) {
      newState.references.references.push(r);
    }
    return newState;
  })
);
